import React from 'react'
import styles from './Style.module.css'
import { useLocation } from "react-router-dom";

const LoaderMain = () => {
  const { pathname } = useLocation();

  return (
    <div className={`${styles.loader} ${pathname === '/' && styles.full}`}>
      <div className={styles.circleBorder}>
        <div className={styles.circleCore}></div>
      </div>  
    </div>
  )
}

export default LoaderMain
